export const ORDER_PLACED = "order placed";
export const INVOICED = "invoiced";
export const PICKED_UP = "picked up";
export const DESIGNED = "designed";
export const INTERNAL_PROOF = "internal proof";
export const EMAILED_TO_CLIENT = "emailed to client";
export const NEEDS_APPROVAL = "needs approval";
export const PDF_APPROVED = "pdf approved";
export const READY_FOR_PRINT = "ready for print";
export const WALL_POSTERS_PRINTED = "wall posters printed";
export const WALL_POSTERS_SHIPPED = "wall posters shipped";
export const FLATS_PRINTED = "flats printed";
export const FLATS_SHIPPED = "flats shipped";
export const PREPPED = "prepped";
export const CLOSED = "closed";
